module.exports = __webpack_public_path__ + "img/28ne.1c469e22.svg";